import { render, staticRenderFns } from "./CallerVerify.vue?vue&type=template&id=be8c71b2"
import script from "./CallerVerify.vue?vue&type=script&lang=js"
export * from "./CallerVerify.vue?vue&type=script&lang=js"
import style0 from "./CallerVerify.vue?vue&type=style&index=0&id=be8c71b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports